<form class="dialog-container">
  <lxm-button class="absolute right-2 top-2" type="transparent" icon="close" (click)="closeDialog()"></lxm-button>

  <section class="flex flex-col items-center" style="padding: 1.875rem">
    <div class="mb-8 flex w-full justify-center">
      <svg-icon key="paidPlanOrange" fontSize="40px"></svg-icon>
    </div>

    <div class="d-title mb-6">
      {{'components.dialogs.quota_restricted.text1' | translate}}
    </div>

    <ng-container [ngSwitch]="canChangeSubscription">

      <ng-container *ngSwitchCase="true">
        <div class="d-text mb-6">
          {{'components.dialogs.quota_restricted.text2' | translate}}
        </div>
  
        <div class="mb-10x flex">
          <lxm-button type="primary" (click)="closeDialog()" routerLink="/lxm-settings/packages">{{
            'components.dialogs.quota_restricted.action.choose_plan' | translate }}</lxm-button>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="false">
        <div class="d-text mb-6">
          {{'components.dialogs.quota_restricted.text2_restricted' | translate}}
        </div>

      </ng-container>

    </ng-container>

    <a class="d-info" href="https://lexi.market/et/hulgimuujale/"
      target="_blank">{{'components.dialogs.quota_restricted.additional_info' | translate}}</a>
  </section>
</form>